import { ButtonGhost, ButtonSecondary, Modal } from '../../views';
import { LabelBody } from '../modules/components';
import classNames from 'classnames';

type SharedProps = {
    title: string;
    body: React.ReactNode;
    className?: string;
    class?: string;
};

type AlertProps = SharedProps & {
    onClose: () => void;
    text: string;
};

// Show a modal with one button.
export function AlertModal({ onClose, text, ...props }: AlertProps) {
    return (
        <ConfirmModal
            {...props}
            onCancel={onClose}
            onConfirm={onClose}
            confirmText={text}
            cancelText=""
        />
    );
}

type ConfirmProps = SharedProps & {
    onCancel: () => void;
    onConfirm: () => void;
    cancelText: string;
    confirmText: string;
};

// Show a modal with two buttons.
export function ConfirmModal({
    title,
    body,
    cancelText,
    confirmText,
    onCancel,
    onConfirm,
    className,
    ...props
}: ConfirmProps) {
    return (
        <Modal
            className={classNames(className, props.class)}
            hideCloseButton
            title={title}
            onClose={onCancel}
        >
            <LabelBody class="mb-20 mt-10">{body}</LabelBody>
            <div className={cancelText ? 'text-center' : 'text-left'}>
                {cancelText && (
                    <ButtonGhost class="mr-20" onClick={onCancel}>
                        {cancelText}
                    </ButtonGhost>
                )}
                <ButtonSecondary onClick={onConfirm}>
                    {confirmText}
                </ButtonSecondary>
            </div>
        </Modal>
    );
}
